import React, { useContext } from "react";

import { Dot, DotWrapper } from "Core/Components/Styles/BaseStyles";
import styled from "styled-components";
import { UnsupportedBrowser } from "./UnsupportedBrowser";
import { UserPage } from "./UserAccess/UserPage";
import { ProductSelector } from "./ProductSelector/ProductSelector";
import { useObserver } from "mobx-react-lite";
import { Stores, StoresContext } from "Custom/Stores";
import Box from "@material-ui/core/Box";

const Section1 = styled.div`
    display: flex;
`;

const Section2 = styled.div`
    display: flex;
    margin: 0 auto;
    max-width: 1170px;
`;

const FlexContainer = styled(Box)`
    display: flex;
`;

const H1 = styled.h1`
    font-weight: 700;
    text-transform: uppercase;
    font-size: 1.6rem;
`;

export const Home: React.FC = () => {
    const storesContext = useContext<Stores>(StoresContext);

    const getSection1 = () => {
        return (
            <Section1>
                <Box width={"100%"}>
                    <UserPage />
                </Box>
            </Section1>
        );
    };

    const getSection2 = () => {
        return (
            <Section2>
                <ProductSelector />
            </Section2>
        );
    };

    return useObserver(() => (
        <>
            {(window as any).IE11 ? (
                <UnsupportedBrowser />
            ) : (
                <>
                    {!storesContext.domain.AccountStore.hasUserAccess && getSection1()}
                    {storesContext.domain.AccountStore.hasUserAccess && getSection2()}
                </>
            )}
        </>
    ));
};

export const Loaders: React.FC = () => {
    return (
        <>
            <Box paddingTop={2}>
                Animated Dots
                <DotWrapper>
                    <Dot delay="0s" />
                    <Dot delay=".1s" />
                    <Dot delay=".2s" />
                </DotWrapper>
            </Box>
        </>
    );
};
